import { render } from "./PartnerInfo.vue?vue&type=template&id=3334b40a&scoped=true"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"

import "./PartnerInfo.vue?vue&type=style&index=0&id=3334b40a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3334b40a"]])

export default __exports__